var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}.cls-2,.cls-3,.cls-4{fill:#cccccb;}.cls-2{opacity:0.7;}.cls-16,.cls-2,.cls-26,.cls-28,.cls-29,.cls-3,.cls-35{isolation:isolate;}.cls-3{opacity:0.8;}.cls-5{fill:#454546;}.cls-6{fill:#83cba6;}.cls-7{fill:#938a86;}.cls-8{fill:#bb203a;}.cls-9{fill:#fedc92;}.cls-10{fill:#fdb926;}.cls-11,.cls-26{fill:#393939;}.cls-12{fill:#df9f26;}.cls-13{fill:#d49429;}.cls-14{fill:#444545;}.cls-15{fill:#535453;}.cls-16{fill:#717272;opacity:0.2;}.cls-17{fill:#474557;}.cls-18{fill:#2e2e2e;}.cls-19{fill:#f16250;}.cls-20{fill:#e64934;}.cls-21{fill:#f2a499;}.cls-22{fill:#c12826;}.cls-23{fill:#f4e9ee;}.cls-24{fill:#d63627;}.cls-25{fill:#474748;}.cls-26{opacity:0.3;}.cls-27{fill:#545554;}.cls-29{font-size:10.99px;letter-spacing:0.14em;}.cls-29,.cls-35,.cls-38{fill:#fff;}.cls-29,.cls-35{font-family:SegoeUI-Bold, Segoe UI;font-weight:700;}.cls-30{letter-spacing:0.12em;}.cls-31{fill:#d8d4d0;}.cls-32{fill:#00a64f;}.cls-33{fill:#1eb35d;}.cls-34{fill:#fafbfb;}.cls-35{font-size:20.42px;letter-spacing:0.13em;}.cls-36{letter-spacing:0.1em;}.cls-37{fill:#81807e;}.cls-39{fill:#eea986;}.cls-40{fill:#a77861;}.cls-41{fill:#007b3e;}.cls-42{fill:#323657;}.cls-43{fill:#ad9f98;}.cls-44{fill:#dfccc5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5427",
    "data-name": "Group 5427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11076",
    "data-name": "Path 11076",
    className: "cls-1",
    d: "M756,107.75c-60-59.48-153.81-91.14-242.55-99-26-2.3-52.14-3.14-78.26-2.9-257.65,2.4-333,99.29-316.57,145.94s63,75.36-4.12,140S-28,453.27,10.39,550.16s201,132.74,423.14,135.7,384.05,11.44,432-78.28-56.92-151.27-71.62-228.16c-9.12-47.66,14.31-95.72,16-143.27C811.8,184.79,790.55,142,756,107.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5311",
    "data-name": "Group 5311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10901",
    "data-name": "Path 10901",
    className: "cls-2",
    d: "M462.51,304.41H320.13c4.89-8.25,18.29-10.32,26.2-9.92,4.3.21,11.15,1.11,14.88-.86,5-2.66,7.57-11.25,11.34-15.43,9.25-10.25,30.59-16.93,35.39.44,1.81,6.52-.59,15,9.82,13.74,4.77-.59,8.3-7,14.13-3.37,2.77,1.74,2,6.17,4.42,7.46,4.21,2.3,4.08-1.64,7.75-2.89C451.17,291.14,460.62,298,462.51,304.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10903",
    "data-name": "Path 10903",
    className: "cls-3",
    d: "M500.56,205.31h205c-6.11,0-10.26-5.26-16.59-6s-12.29,1.24-18.49.17C658,197.36,657.66,183,641,186.21c-7.1,1.35-10.47,5.31-17.68,1.32-4.52-2.5-5.9-8-10-11.11a31.94,31.94,0,0,0-20.11-6c-18.62.18-17.9,9.29-27,17.49-7,6.29-11.07,1.86-18.38,1.39-11.62-.74-12.27,6-21.2,8.78S505.91,197.57,500.56,205.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10904",
    "data-name": "Path 10904",
    className: "cls-2",
    d: "M733.45,146.85H836.59a22.21,22.21,0,0,0-10-4.71c-3.77-.55-7.18,1.26-11,.52-7.75-1.5-6.35-10.55-14.74-11.63-6.2-.79-6.4.88-10.77,3.93-3.87,2.69-5.13,1.79-9.16.52-2.6-.82-3.36-2.28-6.7-1.73s-3.68,2.77-6.39,4.09c-7.54,3.65-9.54-4.48-13.57-8.77C743.46,117.52,721.05,137.55,733.45,146.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10905",
    "data-name": "Path 10905",
    className: "cls-3",
    d: "M9.69,253.85H112.83a22.21,22.21,0,0,0-10-4.71c-3.77-.56-7.19,1.26-11,.52-7.76-1.5-6.35-10.55-14.74-11.63-6.2-.8-6.4.88-10.78,3.92-3.86,2.69-5.12,1.8-9.15.53-2.6-.82-3.36-2.28-6.71-1.73s-3.67,2.77-6.38,4.08c-7.55,3.66-9.55-4.48-13.57-8.76C19.7,224.52-2.71,244.54,9.69,253.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10907",
    "data-name": "Path 10907",
    className: "cls-4",
    d: "M112.83,98.71H285.08c-2.86-4.94-5.83-6.75-10.81-6.84-6.52-.13-6.73.19-11.53-4.71-8-8.16-16.16-12.19-28.68-10-5.88,1.06-10.21,9-16.69,8.91-4.8-.08-6.48-6.08-10.11-7.07s-6.2,3.68-9.39,4.18c-10,1.54-12.34-6.54-20.9-10.45-10.06-4.61-23.31-4.89-31.49,2.16-4.24,3.65-4.48,7-7.81,11.24-3.61,4.64-4.91,3.14-10.1,3.29C120.22,89.67,115.33,92.16,112.83,98.71Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2022",
    "data-name": "Rectangle 2022",
    className: "cls-5",
    y: 571.29,
    width: 845.02,
    height: 114.66
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2026",
    "data-name": "Rectangle 2026",
    className: "cls-6",
    y: 566.57,
    width: 845.02,
    height: 10.99
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2033",
    "data-name": "Rectangle 2033",
    className: "cls-7",
    x: 120.94,
    y: 566.57,
    width: 424.08,
    height: 10.99
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11075",
    "data-name": "Path 11075",
    className: "cls-8",
    d: "M832,263.76a34.27,34.27,0,0,1,1.51-8.87l-.57.27A32.33,32.33,0,0,0,832,263.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_393",
    "data-name": "Ellipse 393",
    className: "cls-5",
    cx: 845.81,
    cy: 631.76,
    r: 54.19
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5388",
    "data-name": "Group 5388"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1800",
    "data-name": "Rectangle 1800",
    className: "cls-9",
    x: 459.06,
    y: 430.88,
    width: 106.39,
    height: 146.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1801",
    "data-name": "Rectangle 1801",
    className: "cls-10",
    x: 458.21,
    y: 431.73,
    width: 23.15,
    height: 145.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1802",
    "data-name": "Rectangle 1802",
    className: "cls-11",
    x: 458.21,
    y: 563.38,
    width: 106.39,
    height: 14.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1803",
    "data-name": "Rectangle 1803",
    className: "cls-10",
    x: 458.21,
    y: 436.86,
    width: 106.39,
    height: 12.54
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1804",
    "data-name": "Rectangle 1804",
    x: 458.21,
    y: 563.43,
    width: 23.15,
    height: 14.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1805",
    "data-name": "Rectangle 1805",
    className: "cls-9",
    x: 683.41,
    y: 436.86,
    width: 137.75,
    height: 140.65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1806",
    "data-name": "Rectangle 1806",
    className: "cls-10",
    x: 683.41,
    y: 436.86,
    width: 137.75,
    height: 12.54
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1807",
    "data-name": "Rectangle 1807",
    className: "cls-10",
    x: 681.13,
    y: 436.86,
    width: 29.43,
    height: 140.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1808",
    "data-name": "Rectangle 1808",
    className: "cls-10",
    x: 801.21,
    y: 453.82,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1809",
    "data-name": "Rectangle 1809",
    className: "cls-10",
    x: 792.65,
    y: 502.14,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1810",
    "data-name": "Rectangle 1810",
    className: "cls-10",
    x: 714.4,
    y: 551.46,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1811",
    "data-name": "Rectangle 1811",
    className: "cls-12",
    x: 680.76,
    y: 529.79,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1812",
    "data-name": "Rectangle 1812",
    className: "cls-10",
    x: 786.24,
    y: 470.5,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1813",
    "data-name": "Rectangle 1813",
    className: "cls-10",
    x: 802.49,
    y: 552.03,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1814",
    "data-name": "Rectangle 1814",
    className: "cls-10",
    x: 753.46,
    y: 544.47,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1815",
    "data-name": "Rectangle 1815",
    className: "cls-12",
    x: 691.31,
    y: 484.9,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1816",
    "data-name": "Rectangle 1816",
    className: "cls-10",
    x: 719.96,
    y: 462.23,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1817",
    "data-name": "Rectangle 1817",
    className: "cls-10",
    x: 760.58,
    y: 446.84,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1818",
    "data-name": "Rectangle 1818",
    className: "cls-12",
    x: 760.58,
    y: 446.84,
    width: 10.55,
    height: 2.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1819",
    "data-name": "Rectangle 1819",
    className: "cls-10",
    x: 535.81,
    y: 445.7,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1820",
    "data-name": "Rectangle 1820",
    className: "cls-10",
    x: 507.73,
    y: 540.2,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1821",
    "data-name": "Rectangle 1821",
    className: "cls-12",
    x: 457.56,
    y: 475.77,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1822",
    "data-name": "Rectangle 1822",
    className: "cls-10",
    x: 549.92,
    y: 508.27,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1823",
    "data-name": "Rectangle 1823",
    className: "cls-10",
    x: 473.24,
    y: 516.82,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1824",
    "data-name": "Rectangle 1824",
    className: "cls-10",
    x: 508.01,
    y: 463.37,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1825",
    "data-name": "Rectangle 1825",
    className: "cls-10",
    x: 542.79,
    y: 552.03,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1826",
    "data-name": "Rectangle 1826",
    className: "cls-12",
    x: 461.26,
    y: 541.2,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1827",
    "data-name": "Rectangle 1827",
    className: "cls-12",
    x: 473.24,
    y: 516.82,
    width: 8.13,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1828",
    "data-name": "Rectangle 1828",
    className: "cls-12",
    x: 535.81,
    y: 445.7,
    width: 16.25,
    height: 3.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5385",
    "data-name": "Group 5385"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1829",
    "data-name": "Rectangle 1829",
    className: "cls-13",
    x: 485.35,
    y: 477.34,
    width: 53.8,
    height: 57.17
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1830",
    "data-name": "Rectangle 1830",
    className: "cls-10",
    x: 485.35,
    y: 477.34,
    width: 51.31,
    height: 54.52
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1831",
    "data-name": "Rectangle 1831",
    className: "cls-11",
    x: 487.91,
    y: 479.93,
    width: 46.2,
    height: 46.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1832",
    "data-name": "Rectangle 1832",
    className: "cls-14",
    x: 491.03,
    y: 483.55,
    width: 33.96,
    height: 34.34
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1839",
    "data-name": "Rectangle 1839",
    className: "cls-15",
    x: 493.66,
    y: 486.54,
    width: 19.72,
    height: 19.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1833",
    "data-name": "Rectangle 1833",
    x: 488.88,
    y: 496.87,
    width: 44.79,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1834",
    "data-name": "Rectangle 1834",
    x: 503.68,
    y: 480.76,
    width: 2.28,
    height: 45.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1835",
    "data-name": "Rectangle 1835",
    x: 520.76,
    y: 480.76,
    width: 2.28,
    height: 45.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1836",
    "data-name": "Rectangle 1836",
    className: "cls-10",
    x: 501.33,
    y: 477.34,
    width: 2.28,
    height: 51.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1837",
    "data-name": "Rectangle 1837",
    className: "cls-10",
    x: 518.4,
    y: 477.34,
    width: 2.28,
    height: 51.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1838",
    "data-name": "Rectangle 1838",
    className: "cls-10",
    x: 487.31,
    y: 494.73,
    width: 47.92,
    height: 2.28
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5386",
    "data-name": "Group 5386"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1829-2",
    "data-name": "Rectangle 1829-2",
    className: "cls-13",
    x: 730.65,
    y: 477.34,
    width: 53.8,
    height: 57.17
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1830-2",
    "data-name": "Rectangle 1830-2",
    className: "cls-10",
    x: 730.65,
    y: 477.34,
    width: 51.31,
    height: 54.52
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1831-2",
    "data-name": "Rectangle 1831-2",
    className: "cls-11",
    x: 733.21,
    y: 479.93,
    width: 46.2,
    height: 46.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1832-2",
    "data-name": "Rectangle 1832-2",
    className: "cls-14",
    x: 736.34,
    y: 483.55,
    width: 33.96,
    height: 34.34
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1839-2",
    "data-name": "Rectangle 1839-2",
    className: "cls-15",
    x: 738.96,
    y: 486.54,
    width: 19.72,
    height: 19.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1833-2",
    "data-name": "Rectangle 1833-2",
    x: 734.18,
    y: 496.87,
    width: 44.79,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1834-2",
    "data-name": "Rectangle 1834-2",
    x: 748.98,
    y: 480.76,
    width: 2.28,
    height: 45.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1835-2",
    "data-name": "Rectangle 1835-2",
    x: 766.06,
    y: 480.76,
    width: 2.28,
    height: 45.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1836-2",
    "data-name": "Rectangle 1836-2",
    className: "cls-10",
    x: 746.63,
    y: 477.34,
    width: 2.28,
    height: 51.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1837-2",
    "data-name": "Rectangle 1837-2",
    className: "cls-10",
    x: 763.71,
    y: 477.34,
    width: 2.28,
    height: 51.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1838-2",
    "data-name": "Rectangle 1838-2",
    className: "cls-10",
    x: 732.62,
    y: 494.73,
    width: 47.92,
    height: 2.28
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1840",
    "data-name": "Rectangle 1840",
    className: "cls-11",
    x: 683.41,
    y: 563.38,
    width: 140.03,
    height: 14.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1841",
    "data-name": "Rectangle 1841",
    x: 684.82,
    y: 563.43,
    width: 25.73,
    height: 14.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10994",
    "data-name": "Path 10994",
    className: "cls-11",
    d: "M350.23,366.73H815l17.53,65v7.41H350.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10995",
    "data-name": "Path 10995",
    className: "cls-16",
    d: "M408.71,373.58,507.59,411v.19H553.2V373.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10996",
    "data-name": "Path 10996",
    className: "cls-14",
    d: "M718.54,373.58V411l97.92.19-9.12-37.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1842",
    "data-name": "Rectangle 1842",
    x: 543.73,
    y: 366.73,
    width: 2.63,
    height: 72.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1843",
    "data-name": "Rectangle 1843",
    x: 516.93,
    y: 366.73,
    width: 2.63,
    height: 72.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1844",
    "data-name": "Rectangle 1844",
    x: 490.13,
    y: 366.73,
    width: 2.63,
    height: 72.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1845",
    "data-name": "Rectangle 1845",
    x: 463.34,
    y: 366.73,
    width: 2.63,
    height: 72.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1846",
    "data-name": "Rectangle 1846",
    x: 436.54,
    y: 366.73,
    width: 2.63,
    height: 64.86
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1847",
    "data-name": "Rectangle 1847",
    x: 409.74,
    y: 366.73,
    width: 2.63,
    height: 64.86
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1848",
    "data-name": "Rectangle 1848",
    x: 382.95,
    y: 366.73,
    width: 2.63,
    height: 64.86
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1849",
    "data-name": "Rectangle 1849",
    x: 806.13,
    y: 366.74,
    width: 2.63,
    height: 72.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1850",
    "data-name": "Rectangle 1850",
    x: 779.34,
    y: 366.74,
    width: 2.63,
    height: 72.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1851",
    "data-name": "Rectangle 1851",
    x: 752.54,
    y: 366.74,
    width: 2.63,
    height: 72.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1852",
    "data-name": "Rectangle 1852",
    x: 725.74,
    y: 366.74,
    width: 2.63,
    height: 72.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1853",
    "data-name": "Rectangle 1853",
    className: "cls-17",
    x: 698.95,
    y: 366.74,
    width: 2.63,
    height: 72.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1854",
    "data-name": "Rectangle 1854",
    className: "cls-18",
    x: 681.13,
    y: 366.73,
    width: 29.43,
    height: 72.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10997",
    "data-name": "Path 10997",
    className: "cls-19",
    d: "M350.23,432.86v6.28H834.56V433Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1855",
    "data-name": "Rectangle 1855",
    className: "cls-20",
    x: 682.2,
    y: 433.01,
    width: 28.27,
    height: 6.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10998",
    "data-name": "Path 10998",
    d: "M623,290.54,533.11,334v7.41l90.79-4.49,88.94,4.78V334Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1867",
    "data-name": "Rectangle 1867",
    className: "cls-20",
    x: 561.26,
    y: 338.77,
    width: 125.65,
    height: 238.74
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1868",
    "data-name": "Rectangle 1868",
    className: "cls-19",
    x: 654.97,
    y: 393.96,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1869",
    "data-name": "Rectangle 1869",
    className: "cls-19",
    x: 662.66,
    y: 539.34,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1870",
    "data-name": "Rectangle 1870",
    className: "cls-19",
    x: 657.96,
    y: 491.74,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1871",
    "data-name": "Rectangle 1871",
    className: "cls-19",
    x: 590.26,
    y: 467.65,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1872",
    "data-name": "Rectangle 1872",
    className: "cls-19",
    x: 572.58,
    y: 503.57,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1873",
    "data-name": "Rectangle 1873",
    className: "cls-19",
    x: 569.59,
    y: 546.04,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1874",
    "data-name": "Rectangle 1874",
    className: "cls-19",
    x: 574.15,
    y: 392.25,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1875",
    "data-name": "Rectangle 1875",
    className: "cls-19",
    x: 566.03,
    y: 475.63,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1876",
    "data-name": "Rectangle 1876",
    className: "cls-19",
    x: 666.65,
    y: 405.22,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1877",
    "data-name": "Rectangle 1877",
    className: "cls-19",
    x: 671.64,
    y: 503,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1878",
    "data-name": "Rectangle 1878",
    className: "cls-19",
    x: 563.6,
    y: 525.8,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1879",
    "data-name": "Rectangle 1879",
    className: "cls-19",
    x: 670.5,
    y: 467.65,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1880",
    "data-name": "Rectangle 1880",
    className: "cls-19",
    x: 566.45,
    y: 405.79,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1881",
    "data-name": "Rectangle 1881",
    className: "cls-19",
    x: 632.62,
    y: 412.46,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1882",
    "data-name": "Rectangle 1882",
    x: 560.77,
    y: 380.84,
    width: 124.42,
    height: 6.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1883",
    "data-name": "Rectangle 1883",
    className: "cls-20",
    x: 560.83,
    y: 339.37,
    width: 124.29,
    height: 41.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1884",
    "data-name": "Rectangle 1884",
    x: 560.77,
    y: 375.86,
    width: 124.42,
    height: 6.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1885",
    "data-name": "Rectangle 1885",
    className: "cls-21",
    x: 560.2,
    y: 377.57,
    width: 125.56,
    height: 6.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1886",
    "data-name": "Rectangle 1886",
    x: 560.77,
    y: 456.67,
    width: 124.42,
    height: 6.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10999",
    "data-name": "Path 10999",
    className: "cls-21",
    d: "M623,295.67l-89.87,43.42v4.08L623.89,342l88.94,1.17v-4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11000",
    "data-name": "Path 11000",
    className: "cls-20",
    d: "M623,299.71l-89.87,43.42H712.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1887",
    "data-name": "Rectangle 1887",
    className: "cls-13",
    x: 596.07,
    y: 382.2,
    width: 53.8,
    height: 26.31
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1888",
    "data-name": "Rectangle 1888",
    className: "cls-13",
    x: 596.07,
    y: 351.34,
    width: 53.8,
    height: 26.37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1889",
    "data-name": "Rectangle 1889",
    className: "cls-13",
    x: 596.07,
    y: 377.57,
    width: 53.8,
    height: 6.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1890",
    "data-name": "Rectangle 1890",
    x: 570.1,
    y: 326.4,
    width: 1.71,
    height: 51.17
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1891",
    "data-name": "Rectangle 1891",
    x: 590.91,
    y: 317.7,
    width: 1.71,
    height: 59.86
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1892",
    "data-name": "Rectangle 1892",
    x: 611.72,
    y: 307.73,
    width: 1.71,
    height: 69.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1893",
    "data-name": "Rectangle 1893",
    x: 632.53,
    y: 307.73,
    width: 1.71,
    height: 69.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1894",
    "data-name": "Rectangle 1894",
    x: 653.34,
    y: 317.7,
    width: 1.71,
    height: 59.86
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1895",
    "data-name": "Rectangle 1895",
    x: 674.15,
    y: 326.4,
    width: 1.71,
    height: 51.17
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1896",
    "data-name": "Rectangle 1896",
    className: "cls-22",
    x: 561.2,
    y: 563.38,
    width: 125.72,
    height: 14.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11015",
    "data-name": "Path 11015",
    d: "M668.66,492.11s-9.27-23.24-41.41-23.24-41.42,23.24-41.42,23.24V577.4h82.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11016",
    "data-name": "Path 11016",
    className: "cls-10",
    d: "M664.39,490.59s-9.28-21.72-41.41-21.72-41.42,21.72-41.42,21.72v86.92h82.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11017",
    "data-name": "Path 11017",
    className: "cls-11",
    d: "M660.46,494.32s-8.4-20.61-37.48-20.61-37.49,20.61-37.49,20.61v83.19h75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11018",
    "data-name": "Path 11018",
    className: "cls-14",
    d: "M645.27,497.53s-6.48-17.18-28.9-17.18-28.9,17.18-28.9,17.18v80h57.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11019",
    "data-name": "Path 11019",
    className: "cls-15",
    d: "M628.24,496.14s-3.49-8.55-15.55-8.55-15.54,8.55-15.54,8.55V544.2h31.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1899",
    "data-name": "Rectangle 1899",
    className: "cls-15",
    x: 597.15,
    y: 565.75,
    width: 31.08,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1900",
    "data-name": "Rectangle 1900",
    x: 590.79,
    y: 526.39,
    width: 3.41,
    height: 18.04,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1903",
    "data-name": "Rectangle 1903",
    x: 641.61,
    y: 498.46,
    width: 4.6,
    height: 79.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1905",
    "data-name": "Rectangle 1905",
    x: 585.49,
    y: 496.44,
    width: 74.97,
    height: 2.85
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1910",
    "data-name": "Rectangle 1910",
    className: "cls-10",
    x: 583.64,
    y: 493.59,
    width: 78.74,
    height: 2.85
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1912",
    "data-name": "Rectangle 1912",
    className: "cls-10",
    x: 639.47,
    y: 495.3,
    width: 4.6,
    height: 82.21
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11020",
    "data-name": "Path 11020",
    className: "cls-23",
    d: "M592.09,542.66h0a1.34,1.34,0,0,1-1.34-1.34v-13.4a1.34,1.34,0,0,1,1.34-1.34h0a1.36,1.36,0,0,1,1.35,1.34h0v13.4a1.34,1.34,0,0,1-1.34,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11021",
    "data-name": "Path 11021",
    className: "cls-24",
    d: "M623,304.84l79.23,38.29h10.62L623,299.71l-89.87,43.42h10.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1915",
    "data-name": "Rectangle 1915",
    className: "cls-10",
    x: 596.07,
    y: 351.34,
    width: 51.31,
    height: 54.52
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1916",
    "data-name": "Rectangle 1916",
    className: "cls-11",
    x: 598.63,
    y: 353.93,
    width: 46.2,
    height: 46.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1917",
    "data-name": "Rectangle 1917",
    className: "cls-25",
    x: 601.76,
    y: 357.55,
    width: 33.96,
    height: 34.34
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1918",
    "data-name": "Rectangle 1918",
    className: "cls-11",
    x: 599.6,
    y: 370.87,
    width: 44.79,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1919",
    "data-name": "Rectangle 1919",
    className: "cls-11",
    x: 614.4,
    y: 354.76,
    width: 2.28,
    height: 45.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1920",
    "data-name": "Rectangle 1920",
    className: "cls-11",
    x: 631.48,
    y: 354.76,
    width: 2.28,
    height: 45.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1921",
    "data-name": "Rectangle 1921",
    className: "cls-10",
    x: 612.05,
    y: 351.34,
    width: 2.28,
    height: 51.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1922",
    "data-name": "Rectangle 1922",
    className: "cls-10",
    x: 629.13,
    y: 351.34,
    width: 2.28,
    height: 51.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1923",
    "data-name": "Rectangle 1923",
    className: "cls-10",
    x: 598.04,
    y: 368.73,
    width: 47.92,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1924",
    "data-name": "Rectangle 1924",
    className: "cls-26",
    x: 604.39,
    y: 360.54,
    width: 19.72,
    height: 19.94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1925",
    "data-name": "Rectangle 1925",
    className: "cls-21",
    x: 560.2,
    y: 453.68,
    width: 125.56,
    height: 6.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11022",
    "data-name": "Path 11022",
    d: "M251.88,319.8,11,411v6.46H492.76V411Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1926",
    "data-name": "Rectangle 1926",
    className: "cls-20",
    x: 451.93,
    y: 432.86,
    width: 29.43,
    height: 6.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11023",
    "data-name": "Path 11023",
    className: "cls-9",
    d: "M251.88,325.5,11,416.72v6.46H492.76v-6.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1927",
    "data-name": "Rectangle 1927",
    className: "cls-9",
    x: 39.79,
    y: 420.45,
    width: 424.08,
    height: 157.07
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1931",
    "data-name": "Rectangle 1931",
    className: "cls-10",
    x: 103.47,
    y: 545.19,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2047",
    "data-name": "Rectangle 2047",
    className: "cls-10",
    x: 143.57,
    y: 500.21,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2048",
    "data-name": "Rectangle 2048",
    className: "cls-10",
    x: 151.7,
    y: 459.67,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1933",
    "data-name": "Rectangle 1933",
    className: "cls-10",
    x: 393.5,
    y: 527.43,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1934",
    "data-name": "Rectangle 1934",
    className: "cls-10",
    x: 55.9,
    y: 446.98,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1935",
    "data-name": "Rectangle 1935",
    className: "cls-10",
    x: 47.77,
    y: 530.36,
    width: 16.25,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1938",
    "data-name": "Rectangle 1938",
    className: "cls-10",
    x: 442.73,
    y: 537.21,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1940",
    "data-name": "Rectangle 1940",
    className: "cls-10",
    x: 48.2,
    y: 460.52,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1941",
    "data-name": "Rectangle 1941",
    className: "cls-10",
    x: 443.59,
    y: 452.11,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1942",
    "data-name": "Rectangle 1942",
    className: "cls-10",
    x: 39.79,
    y: 421.47,
    width: 424.25,
    height: 10.26
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11024",
    "data-name": "Path 11024",
    className: "cls-10",
    d: "M251.88,332,11,423.18H492.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1943",
    "data-name": "Rectangle 1943",
    x: 60.17,
    y: 407.88,
    width: 1.71,
    height: 24.23
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1944",
    "data-name": "Rectangle 1944",
    x: 82.62,
    y: 401.6,
    width: 1.71,
    height: 31.07
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1945",
    "data-name": "Rectangle 1945",
    x: 105.08,
    y: 392.17,
    width: 1.71,
    height: 39.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1946",
    "data-name": "Rectangle 1946",
    x: 127.53,
    y: 384.32,
    width: 1.71,
    height: 48.18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1947",
    "data-name": "Rectangle 1947",
    x: 149.98,
    y: 374.9,
    width: 1.71,
    height: 56.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1948",
    "data-name": "Rectangle 1948",
    x: 172.44,
    y: 368.61,
    width: 1.71,
    height: 63.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1949",
    "data-name": "Rectangle 1949",
    x: 194.89,
    y: 359.19,
    width: 1.71,
    height: 72.69
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1950",
    "data-name": "Rectangle 1950",
    x: 217.34,
    y: 351.34,
    width: 1.71,
    height: 81.24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1951",
    "data-name": "Rectangle 1951",
    x: 239.8,
    y: 341.91,
    width: 1.71,
    height: 90.37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1952",
    "data-name": "Rectangle 1952",
    x: 262.25,
    y: 341.91,
    width: 1.71,
    height: 90.37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1953",
    "data-name": "Rectangle 1953",
    x: 284.7,
    y: 351.34,
    width: 1.71,
    height: 81.24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1954",
    "data-name": "Rectangle 1954",
    x: 307.16,
    y: 359.19,
    width: 1.71,
    height: 72.69
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1955",
    "data-name": "Rectangle 1955",
    x: 329.61,
    y: 368.61,
    width: 1.71,
    height: 63.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1956",
    "data-name": "Rectangle 1956",
    x: 352.06,
    y: 376.47,
    width: 1.71,
    height: 55.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1957",
    "data-name": "Rectangle 1957",
    x: 374.52,
    y: 384.32,
    width: 1.71,
    height: 47.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1958",
    "data-name": "Rectangle 1958",
    x: 396.97,
    y: 393.74,
    width: 1.71,
    height: 38.77
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1959",
    "data-name": "Rectangle 1959",
    x: 419.42,
    y: 401.6,
    width: 1.71,
    height: 31.07
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1960",
    "data-name": "Rectangle 1960",
    x: 441.88,
    y: 411.02,
    width: 1.71,
    height: 21.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11025",
    "data-name": "Path 11025",
    className: "cls-13",
    d: "M311.9,369.23l-57.16-19.15-59.3,19.15v51.66H311.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11026",
    "data-name": "Path 11026",
    className: "cls-9",
    d: "M308.32,368.26,251.88,349l-56.44,19.24v49.18H308.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11027",
    "data-name": "Path 11027",
    className: "cls-11",
    d: "M303.83,370.83l-51.95-17.52-51.95,17.52v42.31h103.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11028",
    "data-name": "Path 11028",
    className: "cls-14",
    d: "M283.1,372.11l-37.85-11.39-37,12V407h74.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11029",
    "data-name": "Path 11029",
    className: "cls-15",
    d: "M244.47,367.26l-26.41,7.4v28h26.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1961",
    "data-name": "Rectangle 1961",
    x: 204.7,
    y: 372.75,
    width: 99.35,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1962",
    "data-name": "Rectangle 1962",
    x: 204.7,
    y: 394.56,
    width: 99.35,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1963",
    "data-name": "Rectangle 1963",
    x: 253.2,
    y: 357,
    width: 2.35,
    height: 52.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1964",
    "data-name": "Rectangle 1964",
    className: "cls-9",
    x: 198,
    y: 370.61,
    width: 108.18,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1965",
    "data-name": "Rectangle 1965",
    className: "cls-9",
    x: 198,
    y: 392.42,
    width: 108.18,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1966",
    "data-name": "Rectangle 1966",
    className: "cls-9",
    x: 250.92,
    y: 351.01,
    width: 2.35,
    height: 64.42
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11030",
    "data-name": "Path 11030",
    className: "cls-13",
    d: "M69.05,420.9H173.24V379.46h-2.85l-101.34,38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11031",
    "data-name": "Path 11031",
    className: "cls-9",
    d: "M69.05,417.43H170.39v-38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11032",
    "data-name": "Path 11032",
    className: "cls-11",
    d: "M85.44,414.54h81.67v-30.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11033",
    "data-name": "Path 11033",
    className: "cls-14",
    d: "M100.53,412.06H158.3V390.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11034",
    "data-name": "Path 11034",
    className: "cls-15",
    d: "M111,410.28h39.15V395.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1967",
    "data-name": "Rectangle 1967",
    x: 140.35,
    y: 395.01,
    width: 2.35,
    height: 18.34
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1968",
    "data-name": "Rectangle 1968",
    className: "cls-9",
    x: 138.07,
    y: 392.92,
    width: 2.35,
    height: 22.52
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11035",
    "data-name": "Path 11035",
    className: "cls-13",
    d: "M438.29,420.9H334.09V379.46h2.85l101.35,38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11036",
    "data-name": "Path 11036",
    className: "cls-9",
    d: "M438.29,417.43H336.94v-38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11037",
    "data-name": "Path 11037",
    className: "cls-11",
    d: "M421.9,414.54H340.22v-30.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11038",
    "data-name": "Path 11038",
    className: "cls-14",
    d: "M406.82,412.06H343.26V388.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11039",
    "data-name": "Path 11039",
    className: "cls-15",
    d: "M389.2,410.1H346.14V394Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1969",
    "data-name": "Rectangle 1969",
    x: 369.33,
    y: 397.34,
    width: 2.35,
    height: 16.01
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1970",
    "data-name": "Rectangle 1970",
    className: "cls-9",
    x: 366.91,
    y: 392.92,
    width: 2.35,
    height: 22.52
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11040",
    "data-name": "Path 11040",
    className: "cls-13",
    d: "M251.88,338.23,476.2,423.18h16.56L251.88,332,11,423.18H27.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1971",
    "data-name": "Rectangle 1971",
    x: 39.72,
    y: 431.73,
    width: 424.32,
    height: 9.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1972",
    "data-name": "Rectangle 1972",
    className: "cls-10",
    x: 38.93,
    y: 432.86,
    width: 425.11,
    height: 6.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1973",
    "data-name": "Rectangle 1973",
    className: "cls-11",
    x: 39.8,
    y: 572.8,
    width: 424.08,
    height: 4.71
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5384",
    "data-name": "Group 5384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11046",
    "data-name": "Path 11046",
    className: "cls-13",
    d: "M336.65,474.07S318,447.15,253.41,447.15s-83.25,26.92-83.25,26.92V572.8H336.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11047",
    "data-name": "Path 11047",
    className: "cls-10",
    d: "M331.94,474.07s-18.64-26.92-83.24-26.92-83.25,26.92-83.25,26.92V572.8H331.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11048",
    "data-name": "Path 11048",
    className: "cls-11",
    d: "M328.8,476.12s-17.59-25.83-78.53-25.83-78.54,25.83-78.54,25.83V572.8H328.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11077",
    "data-name": "Path 11077",
    className: "cls-27",
    d: "M325.66,478.6S309.83,453.43,255,453.43,184.3,478.6,184.3,478.6v94.2H325.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5382",
    "data-name": "Group 5382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11051",
    "data-name": "Path 11051",
    className: "cls-13",
    d: "M432.47,467.34s-6.8-15.48-30.34-15.48-30.34,15.48-30.34,15.48v56.77h60.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11052",
    "data-name": "Path 11052",
    className: "cls-10",
    d: "M430.31,467.34s-6.79-15.48-30.33-15.48-30.34,15.48-30.34,15.48v56.77h60.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11053",
    "data-name": "Path 11053",
    className: "cls-11",
    d: "M428.07,468.13s-6.29-14.31-28.09-14.31-28.1,14.31-28.1,14.31v53.54h56.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11054",
    "data-name": "Path 11054",
    className: "cls-14",
    d: "M419.67,469s-4.83-11.13-21.57-11.13S376.54,469,376.54,469v48.51h43.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2007",
    "data-name": "Rectangle 2007",
    className: "cls-15",
    x: 381.69,
    y: 500.08,
    width: 24.38,
    height: 7.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11055",
    "data-name": "Path 11055",
    className: "cls-15",
    d: "M406.06,469.14s-2.73-6.44-12.19-6.44-12.18,6.44-12.18,6.44V494h24.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2008",
    "data-name": "Rectangle 2008",
    x: 400.78,
    y: 456.52,
    width: 1.6,
    height: 62.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2009",
    "data-name": "Rectangle 2009",
    x: 415.4,
    y: 458.91,
    width: 1.6,
    height: 60.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2010",
    "data-name": "Rectangle 2010",
    x: 386.15,
    y: 458.91,
    width: 1.6,
    height: 60.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2011",
    "data-name": "Rectangle 2011",
    x: 372.95,
    y: 482.88,
    width: 54.14,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2012",
    "data-name": "Rectangle 2012",
    x: 372.95,
    y: 497.02,
    width: 54.14,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2013",
    "data-name": "Rectangle 2013",
    x: 372.95,
    y: 511.02,
    width: 54.14,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2014",
    "data-name": "Rectangle 2014",
    x: 372.95,
    y: 468.75,
    width: 54.14,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2015",
    "data-name": "Rectangle 2015",
    className: "cls-10",
    x: 399.16,
    y: 453.29,
    width: 1.6,
    height: 68.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2016",
    "data-name": "Rectangle 2016",
    className: "cls-10",
    x: 413.79,
    y: 455.92,
    width: 1.6,
    height: 66.27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2017",
    "data-name": "Rectangle 2017",
    className: "cls-10",
    x: 384.53,
    y: 455.92,
    width: 1.6,
    height: 66.27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2018",
    "data-name": "Rectangle 2018",
    className: "cls-10",
    x: 370.27,
    y: 481.32,
    width: 59.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2019",
    "data-name": "Rectangle 2019",
    className: "cls-10",
    x: 370.27,
    y: 495.45,
    width: 59.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2020",
    "data-name": "Rectangle 2020",
    className: "cls-10",
    x: 370.27,
    y: 509.43,
    width: 59.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2021",
    "data-name": "Rectangle 2021",
    className: "cls-10",
    x: 370.27,
    y: 467.19,
    width: 59.4,
    height: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5387",
    "data-name": "Group 5387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11051-2",
    "data-name": "Path 11051-2",
    className: "cls-13",
    d: "M134,467.34s-6.8-15.48-30.34-15.48-30.34,15.48-30.34,15.48v56.77H134Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11052-2",
    "data-name": "Path 11052-2",
    className: "cls-10",
    d: "M131.88,467.34s-6.79-15.48-30.33-15.48-30.34,15.48-30.34,15.48v56.77h60.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11053-2",
    "data-name": "Path 11053-2",
    className: "cls-11",
    d: "M129.64,468.13s-6.29-14.31-28.09-14.31-28.1,14.31-28.1,14.31v53.54h56.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11054-2",
    "data-name": "Path 11054-2",
    className: "cls-14",
    d: "M121.24,469s-4.83-11.13-21.56-11.13S78.11,469,78.11,469v48.51h43.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2007-2",
    "data-name": "Rectangle 2007-2",
    className: "cls-15",
    x: 83.26,
    y: 500.08,
    width: 24.38,
    height: 7.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11055-2",
    "data-name": "Path 11055-2",
    className: "cls-15",
    d: "M107.63,469.14s-2.73-6.44-12.18-6.44-12.19,6.44-12.19,6.44V494h24.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2008-2",
    "data-name": "Rectangle 2008-2",
    x: 102.35,
    y: 456.52,
    width: 1.6,
    height: 62.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2009-2",
    "data-name": "Rectangle 2009-2",
    x: 116.98,
    y: 458.91,
    width: 1.6,
    height: 60.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2010-2",
    "data-name": "Rectangle 2010-2",
    x: 87.72,
    y: 458.91,
    width: 1.6,
    height: 60.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2011-2",
    "data-name": "Rectangle 2011-2",
    x: 74.52,
    y: 482.88,
    width: 54.14,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2012-2",
    "data-name": "Rectangle 2012-2",
    x: 74.52,
    y: 497.02,
    width: 54.14,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2013-2",
    "data-name": "Rectangle 2013-2",
    x: 74.52,
    y: 511.02,
    width: 54.14,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2014-2",
    "data-name": "Rectangle 2014-2",
    x: 74.52,
    y: 468.75,
    width: 54.14,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2015-2",
    "data-name": "Rectangle 2015-2",
    className: "cls-10",
    x: 100.73,
    y: 453.29,
    width: 1.6,
    height: 68.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2016-2",
    "data-name": "Rectangle 2016-2",
    className: "cls-10",
    x: 115.36,
    y: 455.92,
    width: 1.6,
    height: 66.27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2017-2",
    "data-name": "Rectangle 2017-2",
    className: "cls-10",
    x: 86.1,
    y: 455.92,
    width: 1.6,
    height: 66.27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2018-2",
    "data-name": "Rectangle 2018-2",
    className: "cls-10",
    x: 71.85,
    y: 481.32,
    width: 59.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2019-2",
    "data-name": "Rectangle 2019-2",
    className: "cls-10",
    x: 71.85,
    y: 495.45,
    width: 59.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2020-2",
    "data-name": "Rectangle 2020-2",
    className: "cls-10",
    x: 71.85,
    y: 509.43,
    width: 59.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2021-2",
    "data-name": "Rectangle 2021-2",
    className: "cls-10",
    x: 71.85,
    y: 467.19,
    width: 59.4,
    height: 1.6
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2045",
    "data-name": "Rectangle 2045",
    className: "cls-10",
    x: 385.58,
    y: 548.18,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2046",
    "data-name": "Rectangle 2046",
    className: "cls-10",
    x: 343.17,
    y: 504.2,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2049",
    "data-name": "Rectangle 2049",
    className: "cls-10",
    x: 353.77,
    y: 470.8,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2050",
    "data-name": "Rectangle 2050",
    className: "cls-10",
    x: 319.06,
    y: 444.69,
    width: 10.55,
    height: 7.98
  }), /*#__PURE__*/React.createElement("g", {
    id: "DRIVING_SCHOOL_CLOUD",
    "data-name": "DRIVING SCHOOL CLOUD",
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-29",
    transform: "translate(567.37 434.58)"
  }, "DRIVING SCHOOL"), /*#__PURE__*/React.createElement("text", {
    className: "cls-29",
    transform: "translate(602.62 450.29)"
  }, "C", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 8.43,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.35,
    y: 0
  }, "OUD")))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11071",
    "data-name": "Path 11071",
    className: "cls-21",
    d: "M810.27,252.61c-9-.58-13.65,3-13.65,3v19s4.66-3.61,13.65-3.05,14.73,6.48,23.19,2.29a30.56,30.56,0,0,1,0-19.05C825,259.08,819.26,253.18,810.27,252.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5377",
    "data-name": "Group 5377"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2034",
    "data-name": "Rectangle 2034",
    className: "cls-31",
    x: 762.57,
    y: 630.97,
    width: 76.18,
    height: 7.85
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2035",
    "data-name": "Rectangle 2035",
    className: "cls-31",
    x: 640.05,
    y: 630.97,
    width: 76.18,
    height: 7.85
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2036",
    "data-name": "Rectangle 2036",
    className: "cls-31",
    x: 546.49,
    y: 630.97,
    width: 76.18,
    height: 7.85
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2037",
    "data-name": "Rectangle 2037",
    className: "cls-31",
    x: 438.45,
    y: 630.97,
    width: 76.18,
    height: 7.85
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2038",
    "data-name": "Rectangle 2038",
    className: "cls-31",
    x: 330.41,
    y: 630.97,
    width: 76.18,
    height: 7.85
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2039",
    "data-name": "Rectangle 2039",
    className: "cls-31",
    x: 222.36,
    y: 630.97,
    width: 76.18,
    height: 7.85
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2040",
    "data-name": "Rectangle 2040",
    className: "cls-31",
    x: 128.8,
    y: 630.97,
    width: 76.18,
    height: 7.85
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2041",
    "data-name": "Rectangle 2041",
    className: "cls-31",
    x: 6.28,
    y: 630.97,
    width: 76.18,
    height: 7.85
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5380",
    "data-name": "Group 5380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11072",
    "data-name": "Path 11072",
    className: "cls-20",
    d: "M796.62,255.65v19a18.12,18.12,0,0,1,8.45-2.91,69.85,69.85,0,0,1,0-19.05A18.34,18.34,0,0,0,796.62,255.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11073",
    "data-name": "Path 11073",
    className: "cls-20",
    d: "M833.46,273.94a30.56,30.56,0,0,1,0-19.05c-6,3-10.64.86-16-.82a68.29,68.29,0,0,1,0,19.05C822.82,274.8,827.45,276.91,833.46,273.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11074",
    "data-name": "Path 11074",
    className: "cls-20",
    d: "M810.27,269.85c-9-.58-13.65,3-13.65,3v1.81s4.66-3.61,13.65-3.05,14.73,6.48,23.19,2.29c-.18-.52-.34-1.05-.49-1.58C824.78,276.1,819.09,270.4,810.27,269.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11078",
    "data-name": "Path 11078",
    d: "M793.19,246.16h5.11V594.85h-5.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2051",
    "data-name": "Rectangle 2051",
    className: "cls-9",
    y: 577.57,
    width: 164.92,
    height: 17.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2052",
    "data-name": "Rectangle 2052",
    className: "cls-9",
    x: 336.13,
    y: 577.57,
    width: 245.03,
    height: 17.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2053",
    "data-name": "Rectangle 2053",
    className: "cls-9",
    x: 669.11,
    y: 577.57,
    width: 175.92,
    height: 17.28
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_394",
    "data-name": "Ellipse 394",
    className: "cls-9",
    cx: 845.81,
    cy: 586.21,
    r: 8.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_398",
    "data-name": "Ellipse 398",
    cx: 201.83,
    cy: 631.76,
    rx: 168.85,
    ry: 7.07
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_395",
    "data-name": "Ellipse 395",
    className: "cls-6",
    cx: 845.81,
    cy: 572.07,
    r: 5.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5391",
    "data-name": "Group 5391"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2054",
    "data-name": "Rectangle 2054",
    className: "cls-11",
    x: 132.82,
    y: 587.26,
    width: 74.51,
    height: 23.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11079",
    "data-name": "Path 11079",
    d: "M276.47,576.68c-14.16,9.63-22.17,30.89-22.17,30.89H234l-10.2-14.78H38V576.68S290.62,567.06,276.47,576.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11080",
    "data-name": "Path 11080",
    className: "cls-20",
    d: "M261,478.89a1.88,1.88,0,0,1,2-1.79c10.05.41,57.8,2.6,67.62,7.32,7.51,3.61,15.74,17.11,21.54,26.2,4.17,6.51,13.36,21,15.22,28.37a132.13,132.13,0,0,1,2.41,25.72l-2.63,34.13-44.06.07-3.53-11.34a19,19,0,0,0-17.77-12.21h-43V518.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11081",
    "data-name": "Path 11081",
    d: "M335.7,488.2c6,5.68,11.92,15.37,16.42,22.42,3.85,6,12,18.88,14.69,26.62,0,.14.09.28.13.42a6.61,6.61,0,0,1-4-2.36c-.94-1.89-2.16-8.38-17.2-32.86C341.19,495,336.73,490.61,335.7,488.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11082",
    "data-name": "Path 11082",
    d: "M283.22,485.67c11.06.63,35,2.25,42.71,4.87,10,3.42,21.18,29.84,21.71,31l7.56,19.32a.84.84,0,0,1-.54,1.06.8.8,0,0,1-.26.05H334.87a6.39,6.39,0,0,1-2.16-.39l-51.32-19.12a5.93,5.93,0,0,1-3.86-5.56V491.05a5.38,5.38,0,0,1,5.38-5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11083",
    "data-name": "Path 11083",
    className: "cls-11",
    d: "M353,540.08s-7.24-16.23-9.67-21.53c-3.67-8-12.25-24.47-18-26.21-5.32-1.59-20.64-3.54-42.2-4.77h-.2a3.49,3.49,0,0,0-3.49,3.49V517.5a3.21,3.21,0,0,0,2.08,3l37.92,4.68a10.53,10.53,0,0,1,7.53,4.69l6.57,10a3.36,3.36,0,0,0,1.21.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11084",
    "data-name": "Path 11084",
    d: "M320.8,525.46l12.91,14.36-7.14-47.68-1.78-.62,3.51,35.32a1,1,0,0,1-.94,1.13,1,1,0,0,1-.48-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11085",
    "data-name": "Path 11085",
    className: "cls-10",
    d: "M370.6,568c0-.63-.16-1.13-.48-1.15l-6.91-.64c-.58-.06-1.1,1-1.17,2.3l-.32,5.3c-.05.85.21,1.57.59,1.64l7.05,1.21c.31.06.63-.41.67-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2055",
    "data-name": "Rectangle 2055",
    x: 320.8,
    y: 592.8,
    width: 49.81,
    height: 19.97
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2057",
    "data-name": "Rectangle 2057",
    x: 347.21,
    y: 544.27,
    width: 7.66,
    height: 8.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11092",
    "data-name": "Path 11092",
    d: "M324,486.44l-.68-.09-2-.24-7.73-.89-28.81-3.28c-1.53-.16-3.1-.37-4.72-.51a8.93,8.93,0,0,0-2.47.15,9.73,9.73,0,0,0-2.37.9,8.76,8.76,0,0,0-3.58,3.73,8.54,8.54,0,0,0-.83,2.56,10.41,10.41,0,0,0-.12,1.37v1.37c0,7.34,0,15.22,0,23.57,0,16.7,0,35.27,0,55.12v.14h29.95a31.12,31.12,0,0,1,5.1.24,19.86,19.86,0,0,1,15.7,12.55,19.54,19.54,0,0,1,1.06,3.77l.15,1,.07.48,0,.49.05,1,0,.49v.06c-.13-.13.18.19.16.15h37.95v-.14c0-8.56,0-16.82,0-24.71V548.53c0-.91,0-1.82,0-2.72a24,24,0,0,0-.19-2.69,26.78,26.78,0,0,0-3.22-9.79L353,524.81l-8.05-15.1-6.54-12.26L337,494.86c-.23-.41-.42-.82-.66-1.21a11.89,11.89,0,0,0-.77-1.09,16.08,16.08,0,0,0-3.44-3.2,17.06,17.06,0,0,0-5.9-2.56,13.94,13.94,0,0,0-2.21-.36l.56.08c.37.06.91.16,1.63.32a17.27,17.27,0,0,1,5.85,2.59,16,16,0,0,1,3.41,3.2,10.44,10.44,0,0,1,.76,1.08c.23.38.43.8.65,1.21l1.37,2.59,6.51,12.28,8,15.11,4.52,8.53a26.51,26.51,0,0,1,3.18,9.71,26.21,26.21,0,0,1,.19,2.67c0,.9,0,1.81,0,2.72v17.12c0,7.89,0,16.15,0,24.72l.14-.14H323l.14.13v-.06l0-.49-.05-1,0-.49-.07-.49-.16-1a19.6,19.6,0,0,0-1.06-3.83,20.18,20.18,0,0,0-15.94-12.73,32.77,32.77,0,0,0-5.14-.24h-29.8l.14.15c0-19.85,0-38.42,0-55.12,0-8.35,0-16.23,0-23.57a16.39,16.39,0,0,1,.11-2.71,8,8,0,0,1,.81-2.5,8.63,8.63,0,0,1,3.49-3.64,9.25,9.25,0,0,1,2.31-.88,8.56,8.56,0,0,1,2.42-.16c1.6.14,3.18.34,4.71.51l28.81,3.19,7.74.84,2,.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11093",
    "data-name": "Path 11093",
    d: "M279.78,549.26s-.16,0-.44-.06a3.24,3.24,0,0,1-1.17-.47,3,3,0,0,1-1.19-1.55,3.21,3.21,0,0,1-.16-1.23,3,3,0,0,1,.34-1.32,3,3,0,0,1,2.57-1.56h12.34a2.93,2.93,0,0,1,2.89,2.59,3.25,3.25,0,0,1-.35,2,3,3,0,0,1-1.43,1.26,4.45,4.45,0,0,1-1.85.22h-1.82l-3.27,0-4.73.05-1.29,0-.45,0,.45,0,1.29,0,4.73,0,3.27,0h2.78a3.18,3.18,0,0,0,2.56-1.6,3.51,3.51,0,0,0,.39-2.13,3.2,3.2,0,0,0-3.17-2.85l-8.6,0h-3.75a3.14,3.14,0,0,0-3.09,3.12,3.46,3.46,0,0,0,.18,1.28,3.11,3.11,0,0,0,1.29,1.59,2.79,2.79,0,0,0,1.22.43A1.75,1.75,0,0,0,279.78,549.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2056",
    "data-name": "Rectangle 2056",
    className: "cls-10",
    x: 336.9,
    y: 502.98,
    width: 11.3,
    height: 27.11,
    rx: 3.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11090",
    "data-name": "Path 11090",
    className: "cls-10",
    d: "M352.87,546.85h.57V518.19a5.17,5.17,0,0,0-5.16-5.16h-1.36v.57h1.36a4.59,4.59,0,0,1,4.59,4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11091",
    "data-name": "Path 11091",
    className: "cls-10",
    d: "M349,546.89l1.58-26.81a3.38,3.38,0,0,0-3.17-3.57h-.2v.57a2.8,2.8,0,0,1,2.8,2.81v.16l-1.58,26.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11095",
    "data-name": "Path 11095",
    d: "M318.94,612.93l4.7-.33c-1.23-16.28-3-26-5.51-29.78-4.76-7.23-9.49-8.53-14.74-9.39a72.34,72.34,0,0,0-14.56-.43l-1.17,0c-9.83.37-30.42,0-30.63,0l-.08,4.54c.21,0,20.93.34,30.88,0l1.18,0c4.52-.18,4.7.64,9.09,1.37,4.68.77,12.29.65,16,6.34C315.29,587,317.43,592.87,318.94,612.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    className: "cls-10",
    x: 350.04,
    y: 527.43,
    width: 3.12,
    height: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11160",
    "data-name": "Path 11160",
    className: "cls-32",
    d: "M34.56,428.35h223V576h-223Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2061",
    "data-name": "Rectangle 2061",
    className: "cls-33",
    x: 53.41,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2062",
    "data-name": "Rectangle 2062",
    className: "cls-33",
    x: 69.11,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2063",
    "data-name": "Rectangle 2063",
    className: "cls-33",
    x: 84.82,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2064",
    "data-name": "Rectangle 2064",
    className: "cls-33",
    x: 100.53,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2065",
    "data-name": "Rectangle 2065",
    className: "cls-33",
    x: 116.23,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2066",
    "data-name": "Rectangle 2066",
    className: "cls-33",
    x: 131.94,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2067",
    "data-name": "Rectangle 2067",
    className: "cls-33",
    x: 147.65,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2068",
    "data-name": "Rectangle 2068",
    className: "cls-33",
    x: 163.35,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2069",
    "data-name": "Rectangle 2069",
    className: "cls-33",
    x: 179.06,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2070",
    "data-name": "Rectangle 2070",
    className: "cls-33",
    x: 194.77,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2071",
    "data-name": "Rectangle 2071",
    className: "cls-33",
    x: 210.47,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2072",
    "data-name": "Rectangle 2072",
    className: "cls-33",
    x: 226.18,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2073",
    "data-name": "Rectangle 2073",
    className: "cls-33",
    x: 241.89,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11120",
    "data-name": "Path 11120",
    className: "cls-34",
    d: "M345.79,517.14a1.64,1.64,0,0,0,.17-.5c.1-.32.22-.8.36-1.39a20.2,20.2,0,0,0,.6-4.71,10.19,10.19,0,0,0-1.08-4.63,6,6,0,0,0-.81-1.2,1.91,1.91,0,0,0-.37-.38,18.79,18.79,0,0,1,1,1.67,11,11,0,0,1,1,4.54,24.37,24.37,0,0,1-.51,4.67A12.77,12.77,0,0,0,345.79,517.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11121",
    "data-name": "Path 11121",
    className: "cls-34",
    d: "M368.92,557.44a3.18,3.18,0,0,0,0-.62c0-.41,0-1,0-1.73,0-1.46-.15-3.48-.32-5.7s-.39-4.23-.57-5.68c-.09-.72-.17-1.31-.24-1.71a2.71,2.71,0,0,0-.13-.63,2.66,2.66,0,0,0,0,.63l.14,1.73c.13,1.52.3,3.49.48,5.68s.3,4.16.41,5.68c.05.68.1,1.25.13,1.73A2.58,2.58,0,0,0,368.92,557.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5389",
    "data-name": "Group 5389"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_397",
    "data-name": "Ellipse 397",
    cx: 87.56,
    cy: 607.61,
    r: 27.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11125",
    "data-name": "Path 11125",
    className: "cls-11",
    d: "M106.32,607.34a18.76,18.76,0,1,1-19-18.48h0A18.75,18.75,0,0,1,106.32,607.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11127",
    "data-name": "Path 11127",
    className: "cls-10",
    d: "M99.49,607.16a11.65,11.65,0,1,1-11.82-11.48h0A11.64,11.64,0,0,1,99.49,607.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11128",
    "data-name": "Path 11128",
    className: "cls-11",
    d: "M123.11,613.85s4.15-38.64-35.9-38.64c-37,0-36.13,33.25-35.78,38.39h5.79s-2.95-32.76,30-32.76,30.06,33.42,30.06,33.42S119.71,614.13,123.11,613.85Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5390",
    "data-name": "Group 5390"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_397-2",
    "data-name": "Ellipse 397-2",
    cx: 288.28,
    cy: 607.61,
    r: 27.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11125-2",
    "data-name": "Path 11125-2",
    className: "cls-11",
    d: "M307,607.34a18.76,18.76,0,1,1-19-18.48h0A18.75,18.75,0,0,1,307,607.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11127-2",
    "data-name": "Path 11127-2",
    className: "cls-10",
    d: "M300.22,607.16a11.65,11.65,0,1,1-11.82-11.48h0A11.64,11.64,0,0,1,300.22,607.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11128-2",
    "data-name": "Path 11128-2",
    className: "cls-11",
    d: "M323.84,613.85s4.15-38.64-35.9-38.64c-37,0-36.13,33.25-35.79,38.39H258s-2.95-32.76,30-32.76S318,614.26,318,614.26,320.44,614.13,323.84,613.85Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2060",
    "data-name": "Rectangle 2060",
    className: "cls-33",
    x: 37.7,
    y: 428.36,
    width: 3.14,
    height: 147.64
  }), /*#__PURE__*/React.createElement("g", {
    id: "DRIVING_SCHOOL_CLOUD-2",
    "data-name": "DRIVING SCHOOL CLOUD-2",
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-35",
    transform: "translate(42.59 497.47)"
  }, "DRIVING SCHOOL"), /*#__PURE__*/React.createElement("text", {
    className: "cls-35",
    transform: "translate(106.78 532.02)"
  }, "C", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 15.38,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.94,
    y: 0
  }, "OUD")))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_399",
    "data-name": "Ellipse 399",
    cx: 440.58,
    cy: 625.47,
    rx: 19.63,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5426",
    "data-name": "Group 5426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5393",
    "data-name": "Group 5393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11129",
    "data-name": "Path 11129",
    className: "cls-20",
    d: "M435.8,620.9a5.6,5.6,0,0,1-2.87,2.17c-1.68.39-3.33,1-3.35,2.06s4.86,1.7,6.78.63c2.86-1.59,3.16-1.11,3.47-1.91s-.38-2.92-.36-3.18S435.8,620.9,435.8,620.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5394",
    "data-name": "Group 5394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11130",
    "data-name": "Path 11130",
    className: "cls-37",
    d: "M436,620a8.79,8.79,0,0,0-.19.89s3.79.47,3.67-.23-.22-1.18-.22-1.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5395",
    "data-name": "Group 5395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11131",
    "data-name": "Path 11131",
    className: "cls-20",
    d: "M448.42,620.78a5.27,5.27,0,0,1-2.31,2.29c-1.56.63-2.81,1.34-2.78,2.38s3.81,2.07,6.56.09c1.74-1.25,2.29-1.25,2.57-2s-.48-2.83-.47-3.08S448.42,620.78,448.42,620.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5396",
    "data-name": "Group 5396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11132",
    "data-name": "Path 11132",
    className: "cls-37",
    d: "M448.38,619.89a8.69,8.69,0,0,0,.05.89s3.65.32,3.56-.36a5.43,5.43,0,0,0-.35-1.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5397",
    "data-name": "Group 5397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11133",
    "data-name": "Path 11133",
    d: "M435.09,567.58S431.72,582.43,431,587a43.2,43.2,0,0,0-.87,10.64c.39,3.45,5.26,21.28,5.06,22.29s5.1.16,5.1.16-3.71-19.9-3-23.6c.55-2.74,5.35-21,6.09-20s1.65,17.2,2.2,19.9,2.22,24,2.22,24,3.74.55,4.74-.3c0,0,.45-18.21.11-23.27-.14-1.93,2.26-23.12-.81-31.65C450.21,560.61,435.09,567.58,435.09,567.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5398",
    "data-name": "Group 5398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11134",
    "data-name": "Path 11134",
    className: "cls-38",
    d: "M420.43,554.07c2.4-.33,9.95,3,10.64,2.76.47-.17,1.58-3.78,2.37-6.51.47-1.62.83-2.93.88-3h0a15.94,15.94,0,0,0,0,2.93c0,.1.06.15.08.26a.34.34,0,0,0,0,.1c.19.55.27,1.16.43,1.78a9.26,9.26,0,0,1,.26,3.51h0V556c.07,2.34-.09,4.86-.15,6.2a4.88,4.88,0,0,0,.59,3h0l.73-.1.52-.07h0l.7-.1,2.74-.39,1-.14.23,0,1.73-.24,4.89-.69.54-.08.22,0,1.84-.26.84-.11h0s.7-5,.76-7.74a48.39,48.39,0,0,1,1.6-8.36v-.1h0a36.46,36.46,0,0,1,4.77,6c.23.55.95,2.06,1.88,3.9a10.78,10.78,0,0,0,1-2.24v-.08a97.87,97.87,0,0,0-3.45-13.94,27.44,27.44,0,0,0-2.49-4.46,34.71,34.71,0,0,0-4.32-1.93l-.18-.07-.49-.19-.24-.1-.12,0-.1,0h0a12.92,12.92,0,0,0-1.72-.59h-.34c-1.1.07-4.39.37-5.46.47l-.33,0h0l-1.27.58h0l-.07,0c-.46.22-1,.5-1.56.8-1.1.61-2.32,1.32-3.33,1.8s-2.36,1.13-2.47,1.22l-5,14.48-8.72-1.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5399",
    "data-name": "Group 5399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11135",
    "data-name": "Path 11135",
    d: "M435.57,565.27a4.63,4.63,0,0,0-.48,2.31s15.14-1.77,16.73-2.46c0,0,.07-2.06-.27-2.1S435.57,565.27,435.57,565.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5400",
    "data-name": "Group 5400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11136",
    "data-name": "Path 11136",
    className: "cls-39",
    d: "M448.47,532.54c-.05,2.37-4.64,3.67-4.64,3.67s-1.93-2.41-1.47-2.64c.18-.09.26-.45.28-.85a9.74,9.74,0,0,0,0-1.08,2.57,2.57,0,0,0,0-.28s.66-.69,1.5-1.52c1.46-1.44,3.46-3.29,3.47-2.55a.78.78,0,0,1,0,.14A13.38,13.38,0,0,0,448.47,532.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5401",
    "data-name": "Group 5401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11137",
    "data-name": "Path 11137",
    className: "cls-11",
    d: "M448.09,563.39s.33,2.08.36,2.63l.7-.14s-.19-2.2-.31-2.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5402",
    "data-name": "Group 5402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11138",
    "data-name": "Path 11138",
    className: "cls-11",
    d: "M436.83,565s-.27,1.89-.27,2.61l.74-.1s.15-2.36.23-2.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5403",
    "data-name": "Group 5403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11139",
    "data-name": "Path 11139",
    className: "cls-40",
    d: "M446.69,529.07h0s-.2.3-.54.72a9.6,9.6,0,0,1-3.52,2.93,7.61,7.61,0,0,0,0-1.07l-.45-.06a12.15,12.15,0,0,1,1-1.46l.92-.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5404",
    "data-name": "Group 5404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11140",
    "data-name": "Path 11140",
    className: "cls-39",
    d: "M447.58,527.33c-.4.86-.77,1.49-.88,1.74h0a2.89,2.89,0,0,1-.54.72,5.29,5.29,0,0,1-3.55,1.86,3.62,3.62,0,0,1-.46-.06,2.18,2.18,0,0,1-1.58-1.1,12.44,12.44,0,0,1-.78-10.21s7.84-2.22,9.07.14C449.71,522.08,448.52,525.29,447.58,527.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5405",
    "data-name": "Group 5405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11141",
    "data-name": "Path 11141",
    d: "M439.78,520.29s-.73,0-.91-1.41.18-1.75.18-1.75a34.18,34.18,0,0,1,4.4-1.53c1.16-.17,4-.34,4.69.42,0,0,1.63-.37,2.07,2.33.71,4.29-2.39,8.45-2.39,8.45s0-2.8-.6-3.17-1.15.51-1.15.51l-1.25.23s1.92-4.15-.39-4.3S441.1,520.53,439.78,520.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5406",
    "data-name": "Group 5406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11142",
    "data-name": "Path 11142",
    className: "cls-39",
    d: "M446.11,523c.12-1.23,2.36-1.7,2.2-.41s-1.26,2.54-1.75,2.5S446,524,446.11,523Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5407",
    "data-name": "Group 5407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11143",
    "data-name": "Path 11143",
    className: "cls-32",
    d: "M460.58,556.74c-1,1.86-2.51,4.59-4,7.23.2.37.4.74.58,1.09a22.51,22.51,0,0,1,1.15,2.56c.35,1,.83,3.45-.09,3.91l-4.84,2.67-.1-.27c-.16-.44-.51-1.37-1-2.57l-.14-.32c-.09-.23-.23-.55-.39-.93l-.23-.52-.26-.62-.39-.9-.59-1.37,0-.1c-.15-.34-.31-.68-.48-1-.25-.52-.52-1.05-.78-1.57l-.09-.15-.14-.27-.09-.16,0,0,0-.06c-1.4-2.55-3-4.69-3.47-7.82-.05-.3-.1-.6-.14-.9-.08-.49-.14-1-.2-1.47,0-.18,0-.36-.07-.54-.25-2.09-.4-4-.53-5.24-.37-4,2.1-8.41,4-11.11a28.35,28.35,0,0,1,2-2.6h0l.1,0,.13.05.23.09.49.19.18.07c1.84.72,6.17,2,6.66,2.36a35.55,35.55,0,0,1,1.17,4.15,69.83,69.83,0,0,1,2.43,13.83v.08A11.11,11.11,0,0,1,460.58,556.74Zm-7.35-.9a8.13,8.13,0,0,0,.74,3l0,.08c.32-.66.61-1.29.87-1.88h0a15.48,15.48,0,0,0,1.24-3.37,14,14,0,0,0-2.18-6.88h0v.1a78.41,78.41,0,0,0-.69,8.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5408",
    "data-name": "Group 5408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11144",
    "data-name": "Path 11144",
    className: "cls-32",
    d: "M417.22,549.16l11,2.39,5.22-13.66c.12-.09,1.62-.9,2.61-1.37l3.5-1.64,1.51-.69,0,0a64.25,64.25,0,0,0-1.49,7.53h0c0,.19-.05.37-.08.56a.13.13,0,0,1,0,.06l-.06.38v0c0,.08,0,.17,0,.26s-.06.42-.09.65c-.37,2.61-.9,7.06-1.4,11.56h0c-.4,3.55-1.3,7.18-1.59,9.9h0a19.82,19.82,0,0,1-.38,2l-.06.28c-.81,3.42-2.39,8.27-2.39,8.27l-.46-.42-1.36-1.26a1.09,1.09,0,0,1-.3-1.13,94.25,94.25,0,0,0,3.78-17.08h0a19.94,19.94,0,0,0-.73-5.38v0c-.27.75-.57,1.57-.87,2.36h0a15.42,15.42,0,0,1-2,4.23c-.77.28-15.2-3.67-15.3-4.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5409",
    "data-name": "Group 5409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11145",
    "data-name": "Path 11145",
    className: "cls-41",
    d: "M448.93,539.54l-2.23,1.26.95,1-2.54,13.74c-.52-3.22-.76-6.28-.93-8.16-.59-6.24,5.64-13.28,6-13.71l1,.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5410",
    "data-name": "Group 5410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11146",
    "data-name": "Path 11146",
    className: "cls-41",
    d: "M441.09,534.16a73.27,73.27,0,0,0-1.81,9.54c-.37,2.62-.89,7.07-1.4,11.57l-.52-12.87,1.07-1.15-.94-1.19,2-5.18,1.52-.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5411",
    "data-name": "Group 5411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11147",
    "data-name": "Path 11147",
    d: "M450.32,533.69l-1.85-1.14s-.05,1-4.64,3.67l1.3,3.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5412",
    "data-name": "Group 5412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11148",
    "data-name": "Path 11148",
    d: "M442.6,533.06a8.66,8.66,0,0,0,1.23,3.17l-2.55,3.31-.19-5.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5413",
    "data-name": "Group 5413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11149",
    "data-name": "Path 11149",
    className: "cls-42",
    d: "M443.83,536.22a8.61,8.61,0,0,1,.32,2.53,2.47,2.47,0,0,1-1.87-.1A8.74,8.74,0,0,1,443.83,536.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5415",
    "data-name": "Group 5415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5414",
    "data-name": "Group 5414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11150",
    "data-name": "Path 11150",
    className: "cls-43",
    d: "M441.28,564.68a36.66,36.66,0,0,1,0-5.74l.24,0a38.46,38.46,0,0,0,0,5.68Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5416",
    "data-name": "Group 5416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11151",
    "data-name": "Path 11151",
    className: "cls-11",
    d: "M443.21,564s-2.22.26-3,.45l.1,2.49,2.91-.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5417",
    "data-name": "Group 5417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11152",
    "data-name": "Path 11152",
    d: "M442.73,538.47a35,35,0,0,0-2.08,13.29,59.08,59.08,0,0,0,1.11,9.92l1.53,1.92.67-2.36a58,58,0,0,1-.73-18.3c.24-1.64.6-4.74.6-4.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5418",
    "data-name": "Group 5418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11153",
    "data-name": "Path 11153",
    className: "cls-39",
    d: "M450.19,568.09s-.53,1.06-1.07,1.24a4.7,4.7,0,0,0-1.31,1l3.76,2a10.27,10.27,0,0,0,1-3.2C452.65,567.91,450.19,568.09,450.19,568.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5419",
    "data-name": "Group 5419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11154",
    "data-name": "Path 11154",
    className: "cls-44",
    d: "M449.83,568.18l-.25.5a17.11,17.11,0,0,0,3,1.86l.22-.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5420",
    "data-name": "Group 5420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11155",
    "data-name": "Path 11155",
    className: "cls-32",
    d: "M449.58,568.21a18.25,18.25,0,0,0,3.29,2.15l5.06-9.11-2.62-5.07S449.7,567.32,449.58,568.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5421",
    "data-name": "Group 5421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11156",
    "data-name": "Path 11156",
    className: "cls-41",
    d: "M434.38,550.53c-.27.75-.57,1.57-.87,2.36a24.58,24.58,0,0,1-.07-2.57,15.74,15.74,0,0,1,1.61-7.2,15.56,15.56,0,0,0-.58,4.18c-.09,1.69-.08,3.18-.08,3.18h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5422",
    "data-name": "Group 5422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11157",
    "data-name": "Path 11157",
    className: "cls-41",
    d: "M457.14,565.08,453.09,570l3.47-6C456.76,564.34,457,564.71,457.14,565.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5423",
    "data-name": "Group 5423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11158",
    "data-name": "Path 11158",
    className: "cls-20",
    d: "M427.72,558.94h-9.36a1.39,1.39,0,0,1-1.35-1.06L413,541.1a1.39,1.39,0,0,1,1-1.67,1.24,1.24,0,0,1,.33,0h9.35a1.38,1.38,0,0,1,1.35,1.06l4.07,16.78a1.39,1.39,0,0,1-1,1.67A1.12,1.12,0,0,1,427.72,558.94Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5425",
    "data-name": "Group 5425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5424",
    "data-name": "Group 5424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11159",
    "data-name": "Path 11159",
    className: "cls-39",
    d: "M416.28,554.28c.45-.42,1.34-.67,2.09-1.18a.58.58,0,0,0,.32-.77.6.6,0,0,0-.19-.25c.77-.27.69-.63.59-.86s-1-.24-1-.24a8.15,8.15,0,0,0,1.07-.31c.32-.14.21-.69-.27-.86a8.46,8.46,0,0,0-2.45.32l1.29-.65c1-.48,1.18-.92.61-1.13-.4-.15-1.17.15-2.67,1.16-1.12.76-1,.86-1,.86S415.73,554.78,416.28,554.28Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutMain);
export default __webpack_public_path__ + "static/media/about_main.1f928ca1ee1dcdb14116390f1f22b971.svg";
export { ForwardRef as ReactComponent };